var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitterFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    viewBox: "0 0 24.929 24.928",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u7EC4_750",
    "data-name": "\\u7EC4 750",
    transform: "translate(-1826.037 -1047.466)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7EC4_749",
    "data-name": "\\u7EC4 749"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_345",
    "data-name": "\\u8DEF\\u5F84 345",
    d: "M1837.722,1047.466h1.558a1.564,1.564,0,0,0,.188.04,11.87,11.87,0,0,1,5.413,1.721,12.3,12.3,0,0,1,5.893,8.555c.085.453.129.913.192,1.369v1.558c-.02.16-.043.319-.06.48a12.5,12.5,0,0,1-10.234,11.012c-.46.084-.928.13-1.392.193h-1.558c-.3-.037-.609-.07-.912-.113a12.492,12.492,0,0,1-10.579-10.179c-.084-.461-.13-.928-.194-1.393v-1.558c.036-.3.067-.594.108-.89a12.489,12.489,0,0,1,10.233-10.607C1836.824,1047.576,1837.274,1047.528,1837.722,1047.466Zm-4.48,13.766a2.78,2.78,0,0,0,.659,1.11,2.946,2.946,0,0,0,2,.89,5.949,5.949,0,0,1-4.131,1.21,1.186,1.186,0,0,0,.219.157,7.977,7.977,0,0,0,3.988,1.089,7.727,7.727,0,0,0,6.05-2.576,8.187,8.187,0,0,0,2.162-5.658.546.546,0,0,1,.213-.444c.371-.349.713-.728,1.063-1.1a.7.7,0,0,0,.086-.142l-1.452.4-.036-.065a2.869,2.869,0,0,0,1.131-1.437c-.533.187-1.059.368-1.582.557a.3.3,0,0,1-.343-.09,2.846,2.846,0,0,0-4.707,1.4,8.482,8.482,0,0,0-.107,1.338,8.155,8.155,0,0,1-5.813-2.974,2.765,2.765,0,0,0-.372,1.687,2.881,2.881,0,0,0,1.194,2.088l-.039.066-1.17-.328a2.965,2.965,0,0,0,2.164,2.823Z",
    fill: "currentColor"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterFilled);
export default __webpack_public_path__ + "static/media/twitter_filled.62998473.svg";
export { ForwardRef as ReactComponent };